"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMAssignmentCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMOpCode_1 = require("../../../../enums/vm-transformers/VMOpCode");
let VMAssignmentCompiler = class VMAssignmentCompiler {
    constructor(vmCompilerUtils) {
        this.vmCompilerUtils = vmCompilerUtils;
    }
    compileAssignmentExpression(node, context) {
        var _a, _b, _c, _d, _e;
        if (node.operator === '??=' ||
            node.operator === '||=' ||
            node.operator === '&&=') {
            this.compileLogicalAssignment(node, context);
            return;
        }
        if (node.operator !== '=') {
            if (NodeGuards_1.NodeGuards.isIdentifierNode(node.left)) {
                const varName = node.left.name;
                this.vmCompilerUtils.emitLoadVariable(varName, context);
            }
            else if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.left)) {
                this.emitLoadMemberForCompoundAssignment(node.left, context);
            }
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.right);
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.compoundOperator(node.operator);
        }
        if (NodeGuards_1.NodeGuards.isIdentifierNode(node.left)) {
            const varName = node.left.name;
            if (node.operator === '=') {
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(node.right);
            }
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.dup();
            this.vmCompilerUtils.emitStoreVariable(varName, context);
        }
        else if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.left)) {
            this.emitStoreMember(node.left, node.operator === '=', node.right, context);
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(node.left) || NodeGuards_1.NodeGuards.isObjectPatternNode(node.left)) {
            if (node.operator !== '=') {
                throw new Error('Compound assignment with destructuring patterns is not supported');
            }
            (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(node.right);
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.dup();
            (_e = context.dispatch) === null || _e === void 0 ? void 0 : _e.destructuring(node.left, false, true);
        }
    }
    compileLogicalAssignment(node, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isIdentifierNode(node.left)) {
            const varName = node.left.name;
            this.vmCompilerUtils.emitLoadVariable(varName, context);
            builder.dup();
            const jumpOp = node.operator === '??='
                ? VMOpCode_1.VMOpCode.JUMP_NULLISH
                : node.operator === '||='
                    ? VMOpCode_1.VMOpCode.JUMP_IF_TRUE
                    : VMOpCode_1.VMOpCode.JUMP_IF_FALSE;
            const skipIndex = this.vmCompilerUtils.emitConditionalJump(jumpOp, context);
            builder.pop();
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.right);
            builder.dup();
            this.vmCompilerUtils.emitStoreVariable(varName, context);
            this.vmCompilerUtils.patchJump(skipIndex, context);
        }
        else if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.left)) {
            const memberNode = node.left;
            if (memberNode.computed) {
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(memberNode.object);
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(memberNode.property);
                builder.getComputed();
                builder.dup();
                const jumpOp = node.operator === '??='
                    ? VMOpCode_1.VMOpCode.JUMP_NULLISH
                    : node.operator === '||='
                        ? VMOpCode_1.VMOpCode.JUMP_IF_TRUE
                        : VMOpCode_1.VMOpCode.JUMP_IF_FALSE;
                const skipIndex = this.vmCompilerUtils.emitConditionalJump(jumpOp, context);
                builder.pop();
                (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(memberNode.object);
                (_e = context.dispatch) === null || _e === void 0 ? void 0 : _e.expression(memberNode.property);
                (_f = context.dispatch) === null || _f === void 0 ? void 0 : _f.expression(node.right);
                builder.setComputed();
                this.vmCompilerUtils.patchJump(skipIndex, context);
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(memberNode.property)) {
                const propName = memberNode.property.name;
                const propIndex = context.constantPool.add(propName);
                (_g = context.dispatch) === null || _g === void 0 ? void 0 : _g.expression(memberNode.object);
                builder.getPropertyByName(propIndex);
                builder.dup();
                const jumpOp = node.operator === '??='
                    ? VMOpCode_1.VMOpCode.JUMP_NULLISH
                    : node.operator === '||='
                        ? VMOpCode_1.VMOpCode.JUMP_IF_TRUE
                        : VMOpCode_1.VMOpCode.JUMP_IF_FALSE;
                const skipIndex = this.vmCompilerUtils.emitConditionalJump(jumpOp, context);
                builder.pop();
                (_h = context.dispatch) === null || _h === void 0 ? void 0 : _h.expression(memberNode.object);
                (_j = context.dispatch) === null || _j === void 0 ? void 0 : _j.expression(node.right);
                builder.setProperty(propIndex);
                this.vmCompilerUtils.patchJump(skipIndex, context);
            }
        }
    }
    emitLoadMemberForCompoundAssignment(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.object);
        if (node.computed) {
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.property);
            builder.dup();
            builder.getComputed();
        }
        else if (NodeGuards_1.NodeGuards.isIdentifierNode(node.property)) {
            const propIndex = context.constantPool.add(node.property.name);
            builder.dup();
            builder.getPropertyByName(propIndex);
        }
    }
    emitStoreMember(node, isSimpleAssignment, right, context) {
        var _a, _b, _c, _d, _e;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (node.computed) {
            if (isSimpleAssignment) {
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.object);
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.property);
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(right);
            }
            builder.setComputed();
        }
        else {
            if (isSimpleAssignment) {
                (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(node.object);
                (_e = context.dispatch) === null || _e === void 0 ? void 0 : _e.expression(right);
            }
            if (NodeGuards_1.NodeGuards.isIdentifierNode(node.property)) {
                const propIndex = context.constantPool.add(node.property.name);
                builder.setProperty(propIndex);
            }
        }
    }
};
exports.VMAssignmentCompiler = VMAssignmentCompiler;
exports.VMAssignmentCompiler = VMAssignmentCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object])
], VMAssignmentCompiler);
